"use client";
import { Box, SimpleGrid, GridItem, HStack, VStack } from "@chakra-ui/react";
import Image from "next/image";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import PricingFooter from "@/components/pricingFooter";
import { PlainHoverEffect } from "styles/hoverPresets";
import { FOOTER_CONSTANTS } from "./constants";
import { BAREMETAL_SERVER_DATA } from "@/views/pricing/components/tables/baremetal/constants";

const BareMetalServerCard = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box id="pricing">
      <Heading as="h2" variant={HeadingVariant} textAlign={"center"} mb={8}>
        Bare-Metal Server Pricing
      </Heading>
      <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} gap={8}>
        {BAREMETAL_SERVER_DATA.slice(0, 8).map((server) => (
          <GridItem
            key={server.sku}
            borderWidth="1px"
            borderRadius="20px"
            boxShadow={"lg"}
            _hover={PlainHoverEffect}
          >
            <VStack
              gap={1}
              color="white"
              py={2}
              backgroundColor={"primary.200"}
              borderTopRadius="20px"
            >
              <HStack gap={2}>
                <Box
                  h="2rem"
                  position="relative"
                  w="2.2rem"
                  display={"flex"}
                  alignItems={"center"}
                  gap="2px"
                >
                  <Image
                    src={server.wImage}
                    alt="image"
                    style={{ objectFit: "contain" }}
                  />
                </Box>
                <Text
                  fontWeight={600}
                  fontSize={{ base: "md", md: "lg", xl: "md", "2xl": "lg" }}
                >
                  {server.cpu}
                </Text>
                <Text
                  fontWeight={600}
                  fontSize={{ base: "md", md: "lg", xl: "md", "2xl": "lg" }}
                  display={{ base: "none", xl: "block" }}
                >
                  {server.config}
                </Text>
              </HStack>
              <Text
                display={{ base: "block", xl: "none" }}
                fontWeight={600}
                fontSize={{ base: "md", md: "lg" }}
              >
                {server.config}
              </Text>
              <Text fontWeight={600} fontSize={{ base: "sm", xl: "sm" }}>
                {server.sku}
              </Text>
              <Text fontWeight={600} fontSize={"xl"}>
                {server.price}/month
              </Text>
            </VStack>
            <VStack
              gap={2}
              color="text.100"
              backgroundColor={"white"}
              p={4}
              align={"start"}
              borderBottomRadius={"20px"}
            >
              <Box>
                <Text as="span" fontWeight={600}>
                  Memory :{" "}
                </Text>
                <Text as="span">{server.memory}</Text>
              </Box>
              <Box>
                <Text as="span" fontWeight={600}>
                  Base Clock/Boost :{" "}
                </Text>
                <Text as="span">{server.baseclock_boost}</Text>
              </Box>
              <Box>
                <Text as="span" fontWeight={600}>
                  Disk :{" "}
                </Text>
                <Text as="span">{server.disk}</Text>
              </Box>
              <Box>
                <Text as="span" fontWeight={600}>
                  Boot Drives :{" "}
                </Text>
                <Text as="span">{server.bootDrives}</Text>
              </Box>
            </VStack>
          </GridItem>
        ))}
      </SimpleGrid>
      <PricingFooter {...FOOTER_CONSTANTS} />
    </Box>
  );
};

export default BareMetalServerCard;
